/** given an old value, a new value, and an old cursor position, calculate the new cursor position */
function calculateNewCursorPosition(
	oldValue: string,
	newValue: string,
	oldCursorPosition: number | null,
): number {
	if (!oldCursorPosition) return 0;
	const addedCharacters = newValue.length - oldValue.length;
	const basePosition = oldCursorPosition + addedCharacters;
	return Math.min(basePosition, newValue.length);
}

export default calculateNewCursorPosition;
